var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:_vm.classes,attrs:{"id":_vm.id,"data-feather":_vm.iconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }